import { Box } from '@mui/material'
import RoutePreview from '@/components/RoutePreview';


export default function RoutePreviewPage() {
    return (
        <Box>
            <RoutePreview />
        </Box>
    )
}
